import { Component, Input } from '@angular/core';
import { Station } from '../../../../../../client/model/station';
import { StationSet } from '../../../../../../client/model/station-set';

@Component({
    selector: 'app-sac-mobile-transport-actions',
    templateUrl: './transport-actions.component.html',
    styleUrls: ['./transport-actions.component.scss'],
    standalone: false
})
export class MobileSacTransportActionsComponent {

  @Input() station: Station;

  @Input() stationSet: StationSet;



}
